import { useLocation } from "react-router-dom";

import { CircularProgressCenter } from "igfd-ui/src/app-index";

import { DevPage } from "./DevPage";

export const DevFriendlyHome = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();

  // If the home page is being requested, redirect to www.ingredifind.com
  if (location.pathname === "/") {
    // if this is a localhost or a PR link, we don't want to redirect
    // Pr links have the format https://igfd-staff--pr*.web.app
    if (
      window.location.hostname === "localhost" ||
      (window.location.hostname.startsWith("igfd-staff--pr") &&
        window.location.hostname.endsWith(".web.app"))
    ) {
      return <DevPage />;
    }

    open("https://www.ingredifind.com", "_self");
    return <CircularProgressCenter />;
  }

  return <>{children}</>;
};
